import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { SideFilterComponent } from './side-filter.component';
import { TruncatePipe } from '@netfoundry-ui/ui/pipes';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { UiDateRangeQuickHeaderModule } from '@netfoundry-ui/ui/date-range-quick-header';
import { UiDateTimeRangePickerModule } from '@netfoundry-ui/ui/date-time-range-picker';
import { UiFilterSelectModule } from '@netfoundry-ui/ui/filter-select';
import { UiToggleButtonModule } from '@netfoundry-ui/ui/toggle-button';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ClickOutsideModule,
        ClickOutsideModule,
        TruncatePipe,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatButtonModule,
        UiDateRangeQuickHeaderModule,
        UiDateTimeRangePickerModule,
        UiFilterSelectModule,
        UiToggleButtonModule,
    ],
    declarations: [SideFilterComponent],
    exports: [SideFilterComponent],
})
export class FeatureSideFilterModule {}
